<input type="file" (change)="ExcelService.incomingfile($event)" accept=".xlsx" id="excelFile" #excelFile />

<div class="button-container">
	<div class="button danger" (click)="excelFile.value = ''" *ngIf="excelFile.value !== ''">{{ labels.lbl_remover_anexo }}</div>
	<label class="button" for="excelFile">{{
		excelFile.value ? excelFile.value.split('\\')[2] : labels.lbl_importar_planilha_carga
	}}</label>
</div>

<div class="button-container rrow">
	<div class="button success" [ngClass]="{ disabled: isUploadingExcel }" (click)="importExcel()" *ngIf="excelFile.value !== ''">
		{{ labels.lbl_executar_carga }}
		<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isUploadingExcel"></cpi-dot-bounce-loading-effect>
	</div>
</div>
